




import { Component, Prop, Vue } from 'vue-property-decorator';
import type { CdlResult } from '../../models/result.model';

@Component
export default class CdlResultAuthors extends Vue {
  @Prop({ required: true })
  item: CdlResult;

  get authors() {
    return this.item.authors.join(' - ');
  }
}
